// Utility to send an array of payloads over a WebSocket with a small delay between each send.
// This should relieve pressure on the backend.
export async function sendPayloadsWithDelay(websocket: WebSocket | null | undefined, payloads: any[], delayMs: number = 50): Promise<void> {
    const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

    if (!websocket) return;

    for (const payload of payloads) {
        if (websocket.readyState !== WebSocket.OPEN) break;
        try {
            websocket.send(JSON.stringify(payload));
        } catch (error) {
            // Swallow errors here. Not interested in failed websocket sending of logs.
            console.error('Could not send websocket logs to backend', error);
            break;
        }
        if (delayMs > 0) {
            // Add a small random deviation of ±10% so multiple clients are less synchronized.
            const factor = 0.9 + Math.random() * 0.2; // 0.9 .. 1.1
            const jittered = Math.round(delayMs * factor);
            await sleep(jittered);
        }
    }
}
